//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userHeader from '~/components/login/userHeader.vue' // 头部
export default {
  components: {
    'user-header': userHeader
  },
  props: {
    title: {
      type: String,
      default: '语言验证'
    },
    phone: {
      type: [Number, String],
      default: '未传入手机号'
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    voiceClose () { // 点击取消跳转
      this.$emit('loginSwitch', 3)
      // this.$emit('countDown', false)
    }
  }
}
